export function wordUpper(arrWords) {
  const ignore = ["de", "da", "das", "do", "dos"];
  const newArrWord = [];

  for (let i = 0; i < arrWords.length; i++) {
    if (ignore.indexOf(arrWords[i]) === -1) {
      newArrWord[i] =
        arrWords[i].charAt(0).toUpperCase() +
        arrWords[i].slice(1).toLowerCase();
    }
  }
  return newArrWord;
}

export function formatNumber(number) {
  const match =
    number.match(/^(\d{2})(\d{5})(\d{4})$/) ||
    number.match(/^(\d{2})(\d{4})(\d{4})$/);
  return `(${match[1]}) ${match[2]}-${match[3]}`;
}

export function isCpfValid(cpf) {
  let Soma;
  let Resto;
  Soma = 0;

  let strCPF = cpf.replace(/[^\w\s]/gi, "");
  let blacklist = [];
  for (let index = 0; index < 10; index++) {
    const mask = `${index}${index}${index}${index}${index}${index}${index}${index}${index}${index}${index}`;
    blacklist.push(mask);
  }
  const isBlocked = blacklist.filter(item => item === strCPF);
  if (isBlocked.length) return false;

  for (var i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

export function isValidCard(card) {
  const test = card.match(/^(\d{4})\.(\d{4})\.(\d{4})\.(\d{4})$/);
  if (card === "0000.0000.0000.0000") return false;
  if (test !== null) return true;
  return false;
}

export function isExpireDateValid(date) {
  const data = new Date();
  const dateSplit = date.split("/");
  const mes = data.getMonth();
  const ano = data.getFullYear();

  const month = parseInt(dateSplit[0]) - 1;
  const year = parseInt("20" + dateSplit[1]);
  if (year === ano) {
    if (month > mes) {
      return true;
    } else {
      return false;
    }
  } else {
    if (year > ano) {
      if (month < 12 && month >= 0) return true;
      else return false;
    } else return false;
  }
}

export function getErrorRoute(error) {
  const invalidCodes = [
    1100,
    1105,
    1106,
    1110,
    2002,
    2004,
    2005,
    2006,
    2007,
    333,
  ];
  const found = invalidCodes.find(code => code === error) !== undefined;
  if (found) {
    return "InvalidCard";
  } else {
    return "RequestFailure";
  }
}

export function verifyFullName(txt) {
  if (!/(\w.+\s).+/.test(txt)) {
    return false;
  }
  return true;
}

export function hasNumberString(txt) {
  if (!/^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/.test(txt)) {
    return false;
  }

  return true;
}

export function dateOfBirth(date) {
  const isValidDate = !/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(
    date
  );
  const dateSplited = date.split("/");
  const thisDate = new Date(dateSplited[2], dateSplited[1], dateSplited[0]);
  const currentDate = new Date();
  const age = currentDate.getFullYear() - thisDate.getFullYear();
  if (isValidDate || age >= 18) {
    return true;
  }

  return false;
}
